import Footer from "../../components/Footer"
import CategoriesCard from "../../components/categories_list/CategoriesCard"
import CategoriesList from "../../components/categories_list/CategoriesList"
import PageLayout from "../../components/ui/PageLayout"
import FeaturedCategoriesSlider from "./components/FeaturedCategoriesSlider"
import Hero from "./components/Hero"
import HomeAds from "./components/HomeAds"

const Home = () => {
    return (
        <div>
            <Hero />
            <PageLayout>
                <div className="max-w-[90rem] mx-auto">
                    <FeaturedCategoriesSlider />
                </div>
                <div className="pt-4 md:pt-12 grid grid-cols-1 md:grid-cols-7 gap-6 lg:max-w-[90rem] mx-auto relative">
                    {/* Sidebar - CategoriesList for larger screens - with fixed positioning */}
                    <div className="hidden md:block col-span-2">
                        <div className="sticky top-[6rem] max-h-[calc(100vh-2rem)] overflow-y-auto pb-4">
                            <CategoriesList />
                        </div>
                    </div>

                    {/* CategoriesCard for smaller screens */}
                    <div className="block md:hidden">
                        <CategoriesCard />
                    </div>

                    {/* HomeAds content */}
                    <div className="col-span-full px-2 md:col-span-5 max-w-full">
                        <HomeAds />
                    </div>
                </div>
            </PageLayout>
            <Footer />
        </div>
    )
}

export default Home
